import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

const NotFound: React.FC = () => {
  return (
    <div className="bg-gray-50 dark:bg-gray-900 min-h-screen">
      <ScrollToTop />
      <Header />
      
      {/* 404 Section */}
      <section className="relative pt-32 pb-16 md:pt-24 md:pb-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-6xl md:text-8xl font-bold text-gray-900 dark:text-gray-100 mb-6">
            404
          </h1>
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-700 dark:text-gray-300 mb-6">
            Page Not Found
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-400 mb-8 max-w-2xl mx-auto">
            The page you're looking for doesn't exist. It might have been moved, deleted, or you entered the wrong URL.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/"
              className="bg-amber-500 hover:bg-amber-600 text-gray-900 dark:text-gray-900 px-6 py-3 rounded-full transition-colors duration-300 font-medium inline-flex items-center justify-center"
            >
              Go Home
            </Link>
            <button 
              onClick={() => window.history.back()}
              className="bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-900 dark:text-gray-100 px-6 py-3 rounded-full transition-colors duration-300 font-medium inline-flex items-center justify-center"
            >
              Go Back
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NotFound; 